// app/src/config/active.ts
import { PublicKey } from "@solana/web3.js";

type RuntimeConfig = {
  APP_ENV?: string;
  endpoint?: string;
  programId?: string;
};

function readRuntime(): RuntimeConfig {
  const w = typeof window !== "undefined" ? (window as any) : {};
  return (w.__WEARE_SUSU_RUNTIME_CONFIG__ || w.__WEARE_SUSU_RUNTIME__ || w.__WEARE_SUSU_CONFIG__ || {}) as RuntimeConfig;
}

export function getActiveEndpoint(): string {
  const rt = readRuntime();
  const ep = String(rt.endpoint || "").trim();
  return ep || "https://api.testnet.solana.com";
}

export function getActiveProgramIdBase58(): string {
  const rt = readRuntime();
  const pid = String(rt.programId || "").trim();
  return pid || "5bf9hRQ81Mnun8SDUfkanRL7hyCwBycBQLwhcZgkPJsd";
}

export function getActiveProgramId(): PublicKey {
  return new PublicKey(getActiveProgramIdBase58());
}

export function getActiveEnvLabel(): string {
  const rt = readRuntime();
  const env = String(rt.APP_ENV || "").toLowerCase().trim();
  return env || "testnet";
}

export function __activeDebug() {
  return {
    runtime: readRuntime(),
    resolved: {
      env: getActiveEnvLabel(),
      endpoint: getActiveEndpoint(),
      programId: getActiveProgramIdBase58(),
    },
  };
}
